<template>
	<div v-if="passedVendor" class="card p-4 my-2 mx-4">
		<div class="d-flex justify-content-between align-items-start mb-3">
			<div>
				<h4 class="mb-0">{{ vendor.name }} – Details</h4>
			</div>
			<div>
				<b-btn  v-if="isEditing" size="sm" variant="danger" class="mr-2" @click="cancelEdit()">
					abbrechen
				</b-btn>
				<b-btn v-if="isEditing" size="sm" variant="primary" class="mr-2" @click="saveVendor()">
					<span>speichern</span>
				</b-btn>
				<b-btn v-else size="sm" variant="primary" class="mr-2" @click="startEdit()">
					<span ><i class="bi bi-pencil-square"></i></span>
				</b-btn>
				<span :class="['badge p-2 px-3 rounded-pill', vendor.isActive ? 'badge-success' : 'badge-danger']">
        {{ vendor.isActive ? 'aktiv' : 'inaktiv' }}
      	</span>
			</div>

		</div>

		<b-tabs pills v-model="localActiveTab" nav-class="mb-3" active-nav-item-class="rounded-pill" nav-wrapper-class="custom-pills">

			<b-tab title="Übersicht" active title-item-class="me-2" title-link-class="rounded-pill small">
				<div class="p-3">
					<div class="border-top pt-3">

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">LF Name </span>
								<span>{{ vendor.name }}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Kurzform</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.shortForm" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.shortForm || '-' }}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Hauptlieferant</span>
								<span>{{ vendor.mainVendorId === null ? '-' : getMainVendorName(vendor.mainVendorId) }}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">LF Nummer</span>
								<span>{{ vendor.skuPrefix || '-'}}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<div class="d-flex justify-content-between">

									<div>
										<span class="d-block text-muted small text-uppercase">Real Stocks</span>
										<span v-if="isEditing">	<b-form-checkbox
												:checked="Number(tempVendor.hasRealStocks) === 1"
												@change="tempVendor.hasRealStocks = Number($event)"
										>
										{{ tempVendor.hasRealStocks ? 'Ja' : 'Nein' }}
										</b-form-checkbox></span>
										<span v-else>{{ vendor.hasRealStocks ? 'Ja' : 'Nein' }}</span>
									</div>

									<div>

										<span class="d-block text-muted small text-uppercase">Virtual Stocks</span>
										<span v-if="isEditing">	<b-form-checkbox
												:checked="Number(tempVendor.hasVirtualStocks) === 1"
												@change="tempVendor.hasVirtualStocks = Number($event)"
										>
										{{ tempVendor.hasVirtualStocks ? 'Ja' : 'Nein' }}
										</b-form-checkbox></span>
										<span v-else>{{ vendor.hasVirtualStocks ? 'Ja' : 'Nein' }}</span>
									</div>
								</div>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">LK</span>
								<span>{{ vendor.deliveryClass || '-'}}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Land</span>
								<span>{{ countries[vendor.countryId]?.countryName || '-'}}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Strafertrag</span>
								<span>{{ vendor.incomeFine }}</span>
							</div>
						</div>
					</div>

					<div class="border-top pt-3 mt-2">
						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Versandintervall</span>
								<b-form-input v-if="isEditing" v-model="tempVendor.shippingInterval" placeholder="Tage pro Woche"  size="sm"/>
								<span v-else>{{ vendor.shippingInterval || '-' }}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Versanddienstleister</span>
								<!--TODO Rename to Shipping Service?-->
								<span v-if="isEditing"><b-input v-model="tempVendor.shippingCarrier" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.shippingCarrier || '-' }}</span>
							</div>
						</div>
					</div>

					<!-- Kontaktinformationen -->
					<div class="border-top pt-3 mt-2">
						<h6 class="text-uppercase text-muted small font-weight-bold">Kontaktdaten</h6>

						<div class="row">
							<div
									v-for="contactGroup in [
                { key: 'procurementContact', label: 'Account' },
                { key: 'returnsContact', label: 'Retoure' },
            ]"
									:key="contactGroup.key"
									class="col-6"
							>
								<div class="border rounded p-2">
									<div class="d-flex justify-content-between align-items-center mb-2">
										<p class="small font-weight-bold mb-0">
											{{ contactGroup.label }}
										</p>

										<b-button
												v-if="isEditing"
												size="sm"
												variant="outline-primary"
												@click="addContact(contactGroup.key)"
										>
											+
										</b-button>
									</div>

									<div
											v-for="(contact, index) in (isEditing ? tempVendor[contactGroup.key] : vendor[contactGroup.key])"
											:key="index"
											class="border rounded p-2 mb-2"
									>
										<template v-if="isEditing">
											<b-input
													v-model="contact.name"
													size="sm"
													class="mb-1"
													placeholder="Name"
													@keydown.enter="saveVendor()"
											/>

											<b-input
													v-model="contact.email"
													size="sm"
													class="mb-1"
													placeholder="E-Mail"
													@keydown.enter="saveVendor()"
											/>

											<b-input
													v-model="contact.phone"
													size="sm"
													class="mb-1"
													placeholder="Telefon"
													@keydown.enter="saveVendor()"
											/>

											<b-button
													v-if="index !== 0"
													size="sm"
													variant="outline-danger"
													@click="removeContact(contactGroup.key, index)"
											>
												Entfernen
											</b-button>
										</template>

										<template v-else>
											<div class="small font-weight-bold">
												{{ contact.name || '-' }}
											</div>

											<a
													v-if="contact.email"
													class="small"
													:href="`mailto:${contact.email}`"
											>
												{{ contact.email }}
											</a>
											<div v-else class="small">-</div>

											<div class="small">
												{{ contact.phone || '-' }}
											</div>
										</template>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-tab>

			<b-tab title="Zahlung" title-item-class="me-2" title-link-class="rounded-pill small">
				<div class="p-2">
					<div class="border-top pt-3 mt-2">
						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Zahlungsziele</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.paymentDeadline" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.paymentDeadline || '-' }}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Statement</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.statement" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.statement || '-' }}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Kreditlimit</span>
								<!--TODO Zahlenfeld + turnus-->
								<span v-if="isEditing"><b-input v-model="tempVendor.creditLimit" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.creditLimit || '-'}}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Skonto</span>
								<b-input
										v-if="isEditing"
										type="number"
										step="0.01"
										v-model="tempVendor.cashDiscount"
										size="sm"
										:class="{ 'is-invalid': isValidCashDiscount === false }"
										@keydown.enter="saveVendor()"
								/>
								<span v-else>{{ vendor.cashDiscount ? +  vendor.cashDiscount + "%" : '-' }}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Zahlungsintervall</span>
									<span v-if="isEditing"><b-input v-model="tempVendor.paymentInterval" size="sm" @keydown.enter="saveVendor()"></b-input></span>

								<span v-else>{{ vendor.paymentInterval || '-' }}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Zahlungstermin</span>
									<span v-if="isEditing"><b-input v-model="tempVendor.paymentDate" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.paymentDate || '-' }}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Zahlungsart/weg</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.paymentMethod" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.paymentMethod || '-'}}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Gutschriften</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.creditNotes" size="sm" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.creditNotes || '-'}}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Währung</span>
								<b-form-select
										v-if="isEditing"
										v-model="tempVendor.currencyId"
										:options="Object.entries(currencies).map(([id, name]) => ({ value: Number(id), text: name }))"
										size="sm"
								/>
								<span v-else>{{ currencies[vendor.currencyId] }}</span>
							</div>
						</div>
					</div>
				</div>
			</b-tab>

			<b-tab title="Bestellungen" title-link-class="rounded-pill small">
				<div class="p-2">
					<div class="border-top pt-3 mt-2">
						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Händlerseitige Bestellverarbeitung</span>
								<span v-if="isEditing">
									<b-form-select
											v-model="tempVendor.isAutomaticVendorOrderProcessing"
											:options="vendorOrderProcessingOptions"
											size="sm"
									/>
								</span>
								<span v-else>
    							{{
										vendor.isAutomaticVendorOrderProcessing === null
												? '-'
												: vendor.isAutomaticVendorOrderProcessing
														? 'Automatisch'
														: 'Manuell'
									}}
								</span>
							</div>
							<div class="col-6">

								<span class="d-block text-muted small text-uppercase">Backorder (wenn ja, mit Zeitraum)</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.backorderPeriod" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.backorderPeriod || '-' }}</span>
							</div>
						</div>
						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Storno In</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.cancellationInbound" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.cancellationInbound || '-'}}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Storno out</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.cancellationOutbound" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.cancellationOutbound || '-'}}</span>
							</div>
						</div>
						<div class="row mb-3">
							<div class="col-6">

							</div>
						</div>
					</div>
				</div>
			</b-tab>

			<b-tab title="Versand" title-link-class="rounded-pill small">
				<div class="p-2">
					<div class="border-top pt-3 mt-2">
						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Lieferklasse</span>
								<span> {{ vendor.deliveryClass || '-'}}</span>
							</div>
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Versandgruppe</span>
								<span>{{ deliveryGroups.find(group => group.value === vendor.deliveryGroupId)?.text }}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Handlingtime (Tage)</span>
								<span>{{ vendor.handlingTime || '-'}}</span>
							</div>

							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Versandkonditionen</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.shippingConditions" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.shippingConditions || '-'}}</span>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Versanddienstleister</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.shippingCarrier" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.shippingCarrier || '-'}}</span>
							</div>
						</div>
						<div class="row mb-3">
							<div class="col-6">
								<span class="d-block text-muted small text-uppercase">Versandintervall</span>
								<span v-if="isEditing"><b-input v-model="tempVendor.shippingInterval" @keydown.enter="saveVendor()"></b-input></span>
								<span v-else>{{ vendor.shippingInterval || '-'}}</span>
							</div>
						</div>
					</div>
				</div>
			</b-tab>

			<b-tab title="Retouren" title-link-class="rounded-pill small">
				<div class="p-2">
					<div class="row mb-3">
						<div class="col-6">
							<span class="d-block text-muted small text-uppercase">Reklamationsanmeldefrist</span>
							<span v-if="isEditing"><b-input v-model="tempVendor.complaintDeadline" @keydown.enter="saveVendor()"></b-input></span>
							<span v-else>{{ vendor.complaintDeadline || '-'}}</span>
						</div>
						<div class="col-6">
							<span class="d-block text-muted small text-uppercase">Retourenversandintervall</span>
							<span v-if="isEditing"><b-input v-model="tempVendor.returnShippingInterval" @keydown.enter="saveVendor()"></b-input></span>
							<span v-else>{{ vendor.returnShippingInterval || '-'}}</span>
						</div>
					</div>
					<div class="row mb-3">
						<div class="col-6">
							<span class="d-block text-muted small text-uppercase">Kulanzretouren</span>
							<span v-if="isEditing"><b-input v-model="tempVendor.allowGoodwill" @keydown.enter="saveVendor()"></b-input></span>
							<span v-else>{{ vendor.allowGoodwill || '-'}}</span>
						</div>
						<div class="col-6">
							<span class="d-block text-muted small text-uppercase">Kulanzretourenanmeldungintervall</span>
							<span v-if="isEditing"><b-input v-model="tempVendor.goodwillInterval" @keydown.enter="saveVendor()"></b-input></span>
							<span v-else>{{ vendor.goodwillInterval || '-'}} </span>
						</div>
					</div>
				</div>
			</b-tab>

			<!-- Kontaktinformationen -->
			<b-tab title="Kontakte" title-link-class="rounded-pill small">
				<div class="p-2">
					<div class="row">
						<div
								v-for="contactGroup in [
                { key: 'managementContact', label: 'Geschäftsführung' },
                { key: 'procurementContact', label: 'Account' },
                { key: 'returnsContact', label: 'Retoure' },
            ]"
								:key="contactGroup.key"
								class="col-4"
						>
							<div class="border rounded p-2">
								<div class="d-flex justify-content-between align-items-center mb-2">
									<p class="small font-weight-bold mb-0">
										{{ contactGroup.label }}
									</p>

									<b-button
											v-if="isEditing"
											size="sm"
											variant="outline-primary"
											@click="addContact(contactGroup.key)"
									>
										+
									</b-button>
								</div>

								<div
										v-for="(contact, index) in (isEditing ? tempVendor[contactGroup.key] : vendor[contactGroup.key])"
										:key="index"
										class="border rounded p-2 mb-2"
								>
									<template v-if="isEditing">
										<b-input
												v-model="contact.name"
												size="sm"
												class="mb-1"
												placeholder="Name"
												@keydown.enter="saveVendor()"
										/>

										<b-input
												v-model="contact.email"
												size="sm"
												class="mb-1"
												placeholder="E-Mail"
												@keydown.enter="saveVendor()"
										/>

										<b-input
												v-model="contact.phone"
												size="sm"
												class="mb-1"
												placeholder="Telefon"
												@keydown.enter="saveVendor()"
										/>

										<b-button
												v-if="index !== 0"
												size="sm"
												variant="outline-danger"
												@click="removeContact(contactGroup.key, index)"
										>
											Entfernen
										</b-button>
									</template>

									<template v-else>
										<div class="small font-weight-bold">
											{{ contact.name || '-' }}
										</div>

										<a
												v-if="contact.email"
												class="small"
												:href="`mailto:${contact.email}`"
										>
											{{ contact.email }}
										</a>
										<div v-else class="small">-</div>

										<div class="small">
											{{ contact.phone || '-' }}
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</b-tab>

		</b-tabs>
	</div>
</template>

<script>
export default {
	name: "VendorDetailCmp",
	props: {
		passedVendor: Object || null,
		addresses: Object,
		countries: Object,
		currencies: Object,
		deliveryGroups: Object,
		deliveryClasses: Object,
		mainVendors: Object,
		activeTab: {
			type: Number,
			default: 0,
		},
	},
	emits: ['edit-mode-change'],
	watch: {
		passedVendor: {
			handler() {
				this.initializeVendorData();
			},
			immediate: true
		}
	},
	data() {
		return {
			isEditing: false,
			vendor: null,
			tempVendor: null,
			originalValues: null,
		}
	},
	computed: {
		sortedDeliveryGroups() {
			const placeholder = this.deliveryGroups.find(item => item.value === null);
			const realData = this.deliveryGroups.filter(item => item.value !== null);

			realData.sort((a, b) => a.text.localeCompare(b.text));

			return placeholder ? [placeholder, ...realData] : realData;
		},
		localActiveTab: {
			get() {
				return this.activeTab;
			},
			set(value) {
				this.$emit('update:activeTab', value);
			},
		},
		vendorOrderProcessingOptions() {
			const options = [
				{ value: 1, text: 'Automatisch' },
				{ value: 0, text: 'Manuell' },
			];

			if (this.tempVendor.isAutomaticVendorOrderProcessing === null) {
				options.unshift({ value: null, text: 'Bitte wählen' });
			}

			return options;
		}
	},
	methods: {
		startEdit() {
			this.tempVendor = _.cloneDeep(this.vendor);
			this.originalValues = _.cloneDeep(this.vendor);
			this.isEditing = true;
			this.$emit('edit-mode-change', true);
		},

		saveVendor() {
		let payload = _.cloneDeep(this.tempVendor);
		payload.originalValues = this.originalValues;

		axios.put("/vendor/" + this.vendor.id, payload).then( () => {
			//successToast
			this.$bvToast.toast("Änderungen wurden gespeichert", {
				autoHideDelay: 3000,
				appendToast: false,
				variant: "success",
			});
			this.vendor = payload;
			this.tempVendor = null;
			this.isEditing = false;
			this.$emit('edit-mode-change', false);
		}) .catch(error => {
			//errorToast
			this.$bvToast.toast("Fehler beim Speichern der Änderungen", {
				autoHideDelay: 3000,
				appendToast: false,
				variant: "danger",
			});
			console.error(error);
		});
		},

		cancelEdit() {
			this.tempVendor = null;
			this.isEditing = false;
			this.$emit('edit-mode-change', false);
		},
		getMainVendorName(mainVendorId) {
			if (mainVendorId === null) {
				return '-';
			}

			return this.mainVendors.find(mainVendor =>
					mainVendor.value !== null &&
					Number(mainVendor.value) === Number(mainVendorId)
			)?.text ?? '-';
		},

		//set default values for missing fields to prevent errors in the UI and ensure all expected fields are present
		initializeVendorData() {
			this.vendor = {
				...this.passedVendor,


				currencyId : this.passedVendor?.currencyId ? this.passedVendor.currencyId : -1,

				managementContact: this.normalizeContacts(this.passedVendor?.managementContact),
				procurementContact: this.normalizeContacts(this.passedVendor?.procurementContact),
				returnsContact: this.normalizeContacts(this.passedVendor?.returnsContact),
			}
		},
		emptyContact() {
			return {
				name: '',
				email: '',
				phone: '',
			};
		},

		normalizeContacts(contact) {
			if (Array.isArray(contact)) {
				return contact.length ? contact : [this.emptyContact()];
			}

			if (contact) {
				return [contact];
			}

			return [this.emptyContact()];
		},

		addContact(type) {
			this.tempVendor[type].push(this.emptyContact());
		},

		removeContact(type, index) {
			if (index === 0) {
				return;
			}
			this.tempVendor[type].splice(index, 1);

			if (this.tempVendor[type].length === 0) {
				this.tempVendor[type].push(this.emptyContact());
			}
		},
	},
	created() {


	}
}
</script>